(function () {
    'use strict';

    angular
        .module('franchisee-portal.services')
        .service('MediaService', MediaService)

    /** @ngInject */
    function MediaService(HttpService) {
        const MediaService = {
            getAllByParameters: getAllByParameters,
            getCategories: getCategories,
            getByUrl: getByUrl,
            getCommentsByParameters: getCommentsByParameters,
            postAccessLog: postAccessLog,
            postComment: postComment
        }

        return MediaService;

        function getCategories() {
            return HttpService.get('/news/categories');
        }

        function getAllByParameters(params) {
            return HttpService.get('/news/parameters', {
                params
            });
        }

        function getByUrl(url, personId, responsibilityId) {
            return HttpService.get(`/news/${personId}/${responsibilityId}/${url}`)
        }

        function getCommentsByParameters(params) {
            return HttpService.get('/news/comments', {
                params
            });
        }

        function postAccessLog(accessLogData) {
            return HttpService.post('/news/access-log', accessLogData);
        }

        function postComment(commentData) {
            return HttpService.post('/news/comments', commentData);
        }
    }
}());